// src/components/NoOrdersYetPage.jsx
import React, { useState, useEffect } from 'react';
import bag from '../../assets/icons/bag.png';

export default function NoOrdersYetPage() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsSmallMobile(window.innerWidth <= 480);
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Set initial state
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const styles = {
        mainContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#E5D0A5',
            fontFamily: 'Arial, sans-serif',
            position: 'relative',
            padding: '20px',
            boxSizing: 'border-box',
        },
        headerText: {
            position: 'absolute',
            top: '30px',
            left: '30px',
            fontSize: '17px',
            fontWeight: 'bold',
            color: '#000',
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '20px',
            maxWidth: '400px',
        },
        bagIconContainer: {
            position: 'relative',
            width: isSmallMobile ? '80px' : '100px',
            height: isSmallMobile ? '80px' : '100px',
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        mainBagIcon: {
            width: isSmallMobile ? '80px' : '100px',
            height: isSmallMobile ? '80px' : '100px',
        },
        smallBagIcon: {
            position: 'absolute',
            top: isSmallMobile ? '0px' : '5px',
            right: isSmallMobile ? '0px' : '5px',
            width: isSmallMobile ? '40px' : '50px',
            height: isSmallMobile ? '40px' : '50px',
        },
        noOrdersText: {
            fontSize: isSmallMobile ? '24px' : '28px',
            fontWeight: 'bold',
            color: '#000',
            marginBottom: '10px',
        },
        descriptionText: {
            fontSize: isSmallMobile ? '14px' : '16px',
            color: '#555',
            lineHeight: '1.5',
            marginBottom: '25px',
        },
        addButton: {
            backgroundColor: '#000',
            color: '#D4AF37',
            border: 'none',
            borderRadius: '5px',
            padding: '12px 25px',
            fontSize: '15px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
            marginBottom: '15px',
        },
        addButtonHover: {
            backgroundColor: '#333',
        },
        readMoreLink: {
            fontSize: '14px',
            color: '#D4AF37',
            textDecoration: 'none',
            cursor: 'pointer',
            transition: 'text-decoration 0.2s ease',
        },
        readMoreLinkHover: {
            textDecoration: 'underline',
        },
    };

    return (
        <div style={styles.mainContainer}>
            <div style={styles.headerText}>No Order</div>

            <div style={styles.contentWrapper}>
                <div style={styles.bagIconContainer}>
                    {/* Main bag image */}
                    <img src={bag} alt="Shopping bag" style={styles.mainBagIcon} />
                    {/* Smaller bag image on top right */}
                    <img src={bag} alt="Shopping bag" style={styles.smallBagIcon} />
                </div>

                <h2 style={styles.noOrdersText}>No Orders Yet</h2>
                <p style={styles.descriptionText}>
                    Start making sales by adding your products.
                    You can import and manage your product anytime.
                </p>

                <button
                    style={styles.addButton}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.addButtonHover.backgroundColor}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.addButton.backgroundColor}
                >
                    Add Products
                </button>

                <a
                    href="#"
                    style={styles.readMoreLink}
                    onMouseOver={(e) => e.currentTarget.style.textDecoration = styles.readMoreLinkHover.textDecoration}
                    onMouseOut={(e) => e.currentTarget.style.textDecoration = styles.readMoreLink.textDecoration}
                >
                    Read More
                </a>
            </div>
        </div>
    );
}